module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Sea Monsters")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("A VOYAGE AROUND THE WORLD’S MOST BEGUILING MAP")]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('b', [_vm._v("JOSEPH NIGG")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_vm._v("T H E   U N I V E R S I T Y   O F   C H I C A G O   P R E S S")]), _vm._v(" "), _c('p', {
    staticClass: "pub1"
  }, [_vm._v("Chicago and London")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73736436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 60
// module chunks = 0